import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  FormHelperText,
  TextField
} from '@material-ui/core';
import { getCategoryByID, updateCategoryByID } from 'src/redux/vehicles-category/action';
import { useEffect, useState } from 'react';
import { useToast } from 'src/contexts/toast';

const EditCategory = () => {
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [category, setCategory] = useState();
  const categoryID = location.state;

  useEffect(() => {
    const fetchData = async () => {
      const data = await dispatch(getCategoryByID(location.state));
      setCategory(data[0]);
    };
    fetchData();
  }, [categoryID]);

  const goBack = () => {
    navigate('/app/categories');
  };

  return (
    <Container maxWidth={false}>
      <Box paddingTop={3}>
        <Card>
          <CardHeader title="Edit Category" />
        </Card>
      </Box>
      <Box paddingTop={3}>
        <Card>
          <CardContent>
            <Grid container spacing={2} justifyContent="flex-start">
              <Grid item xs={12} sm={6}>
                <Formik
                  enableReinitialize
                  initialValues={{
                    vehicle_category: category ? category.vehicle_category : ''
                  }}
                  validationSchema={Yup.object().shape({
                    vehicle_category: Yup.string()
                      .max(255)
                      .required('category is required')
                  })}
                  onSubmit={async (values) => {
                    try {
                      await dispatch(updateCategoryByID(values, categoryID));
                      showToast("Category is updated successfully!");
                      navigate('/app/categories', { replace: true });
                    } catch (error) {
                      showToast(error.message, "warning");
                    }
                  }}
                >
                  {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    touched,
                    values
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <TextField
                        error={Boolean(
                          touched.vehicle_category && errors.vehicle_category
                        )}
                        fullWidth
                        helperText={touched.vehicle_category && errors.vehicle_category}
                        label="Enter Category"
                        margin="normal"
                        name="vehicle_category"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.vehicle_category}
                        variant="outlined"
                      />
                      {Boolean(touched.policy && errors.policy) && (
                        <FormHelperText error>{errors.policy}</FormHelperText>
                      )}
                      <Box paddingY={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={6}>
                            <Button
                              color="primary"
                              disabled={isSubmitting}
                              size="large"
                              fullWidth
                              type="submit"
                              variant="contained"
                            >
                              UPDATE
                            </Button>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Button
                              color="primary"
                              disabled={isSubmitting}
                              size="large"
                              fullWidth
                              onClick={goBack}
                              variant="contained"
                            >
                              GO BACK
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                    </form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default EditCategory;
